import { useEffect } from "react";
import { Hook } from "../utils/Reference/Hook";

type CacheImagesProps = {
  imagePaths: Record<string, string> | string[] | undefined;
  isTestMaker: boolean;
};

const subdomain = window.location.hostname.split(".")[0].toUpperCase();
const [s3BucketName, s3Region] =
  subdomain === "AU"
    ? ["criteria-corp-object-store-au", "ap-southeast-2"]
    : ["criteria-corp-object-store", "us-east-1"];

const useCacheImages: Hook<CacheImagesProps, void> = ({
  imagePaths,
  isTestMaker
}) => {
  useEffect(() => {
    if (imagePaths) {
      if (Array.isArray(imagePaths)) {
        imagePaths.forEach(path => {
          const image = new Image();
          if (isTestMaker) {
            image.src = `https://${s3BucketName}.s3.${s3Region}.amazonaws.com/hireselect/userfiles/${encodeURI(
              path
            )}`;
          } else {
            image.src = `https://s3.amazonaws.com/criteria-test-images/${path}`;
          }
        });
      } else {
        Object.keys(imagePaths).forEach(path => {
          const img = new Image();
          if (isTestMaker) {
            img.src = `https://${s3BucketName}.s3.${s3Region}.amazonaws.com/hireselect/userfiles/${encodeURI(
              imagePaths[path]
            )}`;
          } else {
            img.src = `https://s3.amazonaws.com/criteria-test-images/${imagePaths[path]}`;
          }
        });
      }
    }
  }, [imagePaths, isTestMaker]);
};

export default useCacheImages;
